if (!customElements.get('percup-wholesale-form')) {
  customElements.define('percup-wholesale-form', class extends HTMLElement {
    connectedCallback() {
      this.fallback = this.querySelector('[data-form-fallback]');
      this.app = this.querySelector('[data-form-app]');
      this.status = this.querySelector('[data-form-status]');
      this.loading = this.querySelector('[data-form-loading]');
      this.recovery = this.querySelector('[data-form-recovery]');
      this.keepFallback = !!this.fallback.querySelector('[data-native-result]');
      this.onInput = () => { this.keepFallback = true; };
      this.onRetry = () => window.location.reload();
      this.fallback.addEventListener('input', this.onInput);
      this.fallback.addEventListener('change', this.onInput);
      this.querySelector('[data-form-retry]').addEventListener('click', this.onRetry);
      if (this.keepFallback) {
        this.app.hidden = true;
      } else {
        this.fallback.hidden = true;
        this.status.hidden = false;
        this.loading.hidden = false;
        this.recovery.hidden = true;
        this.failureTimer = setTimeout(() => this.showFallback(), 15000);
      }
      const connect = () => {
        if (!this.isConnected) return;
        const root = this.querySelector('shopify-forms-embed')?.shadowRoot;
        if (root && this.root !== root) {
          this.observer?.disconnect();
          this.root = root;
          this.observer = new MutationObserver(() => this.prepare());
          this.observer.observe(root, { childList: true, characterData: true, subtree: true });
        }
        if (this.root) this.prepare();
        else this.timer = setTimeout(connect, 500);
      };
      connect();
    }
    showFallback() {
      this.app.hidden = true;
      this.fallback.hidden = false;
      this.loading.hidden = true;
      this.recovery.hidden = false;
      this.status.hidden = false;
    }
    prepare() {
      if (!this.root.getElementById('percup-original-form-style')) {
        const style = document.createElement('link');
        style.id = 'percup-original-form-style';
        style.rel = 'stylesheet';
        style.href = this.dataset.stylesheet;
        this.root.append(style);
      }
      const form = this.root.querySelector('form[data-testid="form"]');
      if ((form || this.root.querySelector('[data-testid="banner-success"]')) && !this.keepFallback) {
        clearTimeout(this.failureTimer);
        this.app.hidden = false;
        this.fallback.hidden = true;
        this.status.hidden = true;
      }
      if (!form) return;
      const accountType = this.root.getElementById('custom#account_type-selector-value');
      form.toggleAttribute('data-business-account', accountType?.textContent.trim() === 'Company');
      const submit = form.querySelector('button[type="submit"]');
      const consent = form.querySelector('fieldset[name="emailConsent"]')?.parentElement;
      if (consent?.parentElement === form && submit && consent.nextElementSibling !== submit) {
        form.insertBefore(consent, submit);
      }
      const placeholders = [
        ['custom#city_country', this.dataset.cityPlaceholder],
        ['custom#business_website_or_social_link', this.dataset.websitePlaceholder]
      ];
      for (const [id, placeholder] of placeholders) {
        const input = this.root.getElementById(id);
        if (input && placeholder && input.placeholder !== placeholder) input.placeholder = placeholder;
      }
      const phone = this.root.getElementById('custom#phone_number');
      if (phone) phone.inputMode = 'tel';
      const message = form.querySelector('textarea[name="custom#message_optional"]');
      if (message) {
        message.id = 'custom#message_optional';
        message.rows = 4;
        message.placeholder = this.dataset.messagePlaceholder;
      }
      const business = this.root.getElementById('custom#business_type-selector-value');
      if (business) business.dataset.placeholder = this.dataset.businessPlaceholder;
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.failureTimer);
      this.observer?.disconnect();
      this.fallback?.removeEventListener('input', this.onInput);
      this.fallback?.removeEventListener('change', this.onInput);
      this.querySelector('[data-form-retry]')?.removeEventListener('click', this.onRetry);
    }
  });
}
